var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service)?_c('article',{staticClass:"landing-service-item",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"landing-service-item__inner"},[_c('service-header',{attrs:{"service":_vm.service}}),_c('unicon',{staticClass:"landing-service-item__chevron",attrs:{"name":"angle-right-b","fill":_vm.scssColors.neutralColor1}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }